import _ from 'lodash';
import React, { useEffect, useState } from 'react';
import { Modal } from 'semantic-ui-react'
import Formsy from 'formsy-react';
import closeIcon from '../../../assets/images/newui/close.png'
import DGTextarea from 'components/FormControls/TextareaStepByStep/DGTextareaStepByStep';
import "./AddRequestNoteModal.less"

function AddRequestNoteModal({label, isOpen , onClose, onSubmit, placeholder, header, submitButtonText}) {
  
  const [noteState ,setNoteState ] = useState("");

  const handleNoteChange = (data)=>{
    setNoteState(data.value)
  }
  
  useEffect(() => {
    if (isOpen) {
      setNoteState("")
    }
  }, [isOpen])

return (
    <Modal
      open={isOpen}
      closeOnDimmerClick={false}
      onClose={() => onClose()}
      className="seller-notes-modal"
    >
      <Formsy>
        <div className="header">
          <div
            className="close-button"
            onClick={() => onClose()}
          >
            <img src={closeIcon}></img>
          </div>
          <div className="main-heading">{ header || "Additional Details"} </div>
        </div>
        <div className="body">
          <div id={"additional-detail-text-area_id"}>
            <DGTextarea
              name={`seller-notes-text-area`}
              label={ label || `Additional Details`}
              value={noteState}
              onChange={(e, data) => {
                handleNoteChange(data);
              }}
              {...{
                maxLength: 10000,
                placeholder: placeholder || "Additional details",
              }}
            ></DGTextarea>
          </div>

          <div className="btn-container">
            <button
              type="button"
              className="button-submit"
              onClick={() => onSubmit(noteState)}
            >
               {submitButtonText || "Continue"}
            </button>
          </div>
        </div>
      </Formsy>
    </Modal>
  );
}


export default AddRequestNoteModal